export { rs } from '@payloadcms/translations/languages/rs'
